import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import fhirExtensionUrls from '@rs-core/fhir/extension/fhirExtensionUrls';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Avatar from '@mui/material/Avatar';

import PdfIcon from '@worklist-2/ui/src/assets/icons/UserProfile/PdfIcon.svg';
import { formatIsoStringToFormDate, BLUME_REPORT_LIST_ITEM_STYLES } from './BlumeReportListItem.config';

export default function BlumeReportListItem({ report, selectReport, selected, study }) {
	const { t } = useTranslation('homepage');

	const reportTitle = useMemo(() => {
		const [{ title }] = report.resource.presentedForm;
		return title;
	}, [report]);

	const reportDate = useMemo(() => {
		const signedDateTimeExtension = report.resource.extension.find(
			extension => extension.url === fhirExtensionUrls.common.signedDateTimeUTC && extension.valueDateTime
		);

		if (signedDateTimeExtension) {
			return formatIsoStringToFormDate(signedDateTimeExtension.valueDateTime);
		}

		const { effectiveDateTime } = report.resource;

		if (effectiveDateTime) {
			return formatIsoStringToFormDate(effectiveDateTime);
		}

		return formatIsoStringToFormDate(study.studyDisplayDateTime);
	}, [report, study]);

	const handleClick = () => {
		selectReport(report);
	};

	return (
		<Box sx={BLUME_REPORT_LIST_ITEM_STYLES.WRAPPER(selected)} onClick={handleClick}>
			<Box sx={{ display: 'flex', gap: '10px' }}>
				<Avatar sx={BLUME_REPORT_LIST_ITEM_STYLES.AVATAR}>
					<PdfIcon />
				</Avatar>
				<Box sx={{ display: 'flex', flexDirection: 'column' }}>
					<Typography sx={BLUME_REPORT_LIST_ITEM_STYLES.REPORT_TITLE}>{reportTitle}</Typography>
					<Typography sx={BLUME_REPORT_LIST_ITEM_STYLES.REPORT_DATE}>{reportDate}</Typography>
				</Box>
			</Box>
			<Button edge="end" endIcon={<ArrowForwardIosIcon />} sx={BLUME_REPORT_LIST_ITEM_STYLES.VIEW_ICON}>
				{t('View')}
			</Button>
		</Box>
	);
}
